import { render } from "./BaseSwiper.vue?vue&type=template&id=ee0831b4&scoped=true"
import script from "./BaseSwiper.vue?vue&type=script&lang=js"
export * from "./BaseSwiper.vue?vue&type=script&lang=js"

import "./BaseSwiper.vue?vue&type=style&index=0&id=ee0831b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee0831b4"]])

export default __exports__